// TODO remove
import '../styles/globals.css'
import 'antd/dist/antd.css'
import { useEffect, useState } from 'react'
import App from 'next/app'
import Head from 'next/head'
import cookies from 'next-cookies'
import Router from 'next/router'
import { identifyEvent, initAckoAnalytics } from '@acko-tech/building-blocks.ui.acko-analytics'
import isMobile from '@utils/isMobile'
import AppContext from '@components/custom-hooks/useAppContext'
import { isLoggedIn as isLoggedInUtil } from '@utils/index'
import windowResizeHook from '@components/custom-hooks/useWindowResize'
import AuthError from './error'
import { getUserDetails } from '@utils/authLogin'
import { initGlobals } from '../utils/global'
import Header from '@components/CommonHeader'

function CentralFrontendApp({ Component, appProps, isMobile, isLoggedIn, isCorpCookie, userDetail, corp_session }) {
  const [isDeviceMobile, setIsDeviceMobile] = useState(isMobile)
  windowResizeHook({ setIsDeviceMobile })

  const r2d2Data = {
    edata: {
      lob: 'central',
      product: 'cx_kms',
    },
    odata: {
      customer_name: userDetail?.name,
      customer_email: userDetail?.email,
    },
  }

  useEffect(() => {
    initGlobals()
    if (!isCorpCookie) Router.push('/error')
    if (userDetail.email && isCorpCookie) {
      identifyEvent(userDetail.email, {})
      r2d2({
        ekind: 'landing_page_loaded',
        okind: 'cx_kms',
        oid: '',
        edata: r2d2Data.edata,
        odata: r2d2Data.odata,
      }).catch(() => null)
    }
  }, [])

  return (
    <AppContext.Provider
      value={{
        isMobile: isDeviceMobile,
        isLoggedIn,
      }}
    >
      <Head>
        <title>Central Frontend Service</title>
        <meta name="robots" content="noindex" />
        {isCorpCookie && (
          <>
            <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: initAckoAnalytics(corp_session, process.env.NEXT_PUBLIC_SEGMENT_KEY || ''),
              }}
            ></script>
          </>
        )}
      </Head>
      {isCorpCookie ? (
        <>
          <Header isDisplay={true} />
          <Component {...appProps} {...userDetail} />
        </>
      ) : (
        <AuthError />
      )}
      <style global jsx>{`
        html {
          width: 100%;
          height: 100%;
        }
        body {
          font-family: 'Inter';
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          background: #ffffff;
          scroll-behavior: smooth;
          box-sizing: border-box;
          display: block;
        }
        #__next {
          width: 100%;
          height: 100%;
        }
        *,
        *:before,
        *:after {
          box-sizing: inherit;
          font-family: inherit;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type='number'] {
          -moz-appearance: textfield;
        }
      `}</style>
    </AppContext.Provider>
  )
}

// Only uncomment this method if you have blocking data requirements for
// every single page in your application. This disables the ability to
// perform automatic static optimization, causing every page in your app to
// be server-side rendered.
//
CentralFrontendApp.getInitialProps = async ({ Component, ctx }) => {
  let appProps = {}
  let isCorpCookie = true
  const userDetail = { name: '', email: '' }
  const { corp_session } = cookies(ctx)
  if (!corp_session) {
    isCorpCookie = false
  } else {
    const Request = ctx.req
    await getUserDetails(Request)
      .then(res => {
        userDetail.name = res.userName
        userDetail.email = res.userEmail
      })
      .catch(() => {
        userDetail.name = ''
        userDetail.email = ''
      })
  }
  try {
    if (Component.getInitialProps) {
      // pageProps = await Component.getInitialProps(ctx)
      // calls page's `getInitialProps` and fills `appProps.pageProps`
      appProps = await App.getInitialProps(ctx)
    }

    let isLoggedIn = false
    isLoggedIn = isLoggedInUtil(ctx?.req)
    return {
      appProps,
      isMobile: isMobile(ctx?.req),
      isLoggedIn,
      isCorpCookie,
      userDetail,
      corp_session,
    }
  } catch (error) {
    // Capture errors that happen during a page's getInitialProps.
    // This will work on both client and server sides.
    // const errorEventId = captureException(error, ctx);
    console.log('In App Error', error)
    return {
      isMobile: isMobile(ctx.req),
      isLoggedIn: isLoggedInUtil(ctx?.req),
      hasError: true,
      isCorpCookie,
      // errorEventId: 0, //errorEventId,
      appProps,
      corp_session,
      userDetail,
    }
  }
}

export default CentralFrontendApp
